(function () {
    'use strict';

    angular
        .module('franchisee-portal.components')
        .controller('ArtsSolicitationQueueListController', ArtsSolicitationQueueListController);

    /** @ngInject */
    function ArtsSolicitationQueueListController($scope, $q, $state, $location, $stateParams, $rootScope, HelpdeskService, AuthenticationService, HelperService, DATA_EVENTS) {
        const vm = this;
        const queryString = $location.search();

        let artsPerPage;
        let artsSkip;
        let forcePaginationReset;
        let isTableSearch;

        vm.isSearchDisabled = () => {
            if (vm.selectedArtTypes || vm.selectedStatus || vm.datePicker.date.startDate || vm.searchText)
                return false;

            return true;
        }

        vm.isClearDisabled = () => {
            if (isTableSearch)
                return false;

            if (vm.selectedArtTypes || vm.selectedStatus || vm.datePicker.date.startDate || vm.searchText || queryString.getOnlyClosed != null)
                return false;

            return true;
        }

        vm.doSearch = (event, isFromButton) => {
            if ((event && event.keyCode == 13) || isFromButton) {
                forcePaginationReset = true;
                isTableSearch = true;

                vm.getPaginatedSolicitations({
                    page: vm.currentPage
                });
            }
        }

        vm.clearSearch = () => {
            vm.searchText = null;
            vm.selectedArtTypes = null;
            vm.selectedStatus = null;
            vm.datePicker.date.startDate = null;
            vm.datePicker.date.endDate = null;

            if (queryString.getOnlyClosed != null) {
                $state.go('app-master.default.helpdesk-queue', {
                    getOnlyClosed: null
                });
            }

            isTableSearch = false;

            vm.getPaginatedSolicitations({
                page: vm.currentPage
            });
        }

        vm.getPaginatedSolicitations = pageData => {
            if (vm.isLoading)
                return;

            if (forcePaginationReset) {
                vm.currentPage = 1;
                forcePaginationReset = false;
            } else
                vm.currentPage = pageData.page;

            artsSkip = (vm.currentPage - 1) * artsPerPage;

            getArtsSolicitations();
        }

        vm.onSelectQueue = isOnlyClosed => {
            $state.go('app-master.default.arts-solicitation-queue', {
                getOnlyClosed: isOnlyClosed
            }, {
                notify: false
            }).then(() => {
                getArtsSolicitations();
            });
        }

        vm.isOnlyClosed = isOnlyClosed => {
            if (queryString.getOnlyClosed == null)
                return false;

            return queryString.getOnlyClosed == isOnlyClosed;
        }

        let removeWatchUnit = $rootScope.$on(DATA_EVENTS.SELECTED_UNIT_CHANGE, () => {
            init();
        })

        $scope.$on('$destroy', () => {
            removeWatchUnit();
        })

        init();

        function getArtsSolicitations() {
            HelperService.startLoading('.arts-holder');
            HelperService.startLoading('.card');

            vm.tickets = [];
            vm.isLoading = true;

            let parameters = prepareParameters();

            HelpdeskService
                .getAllByParameters(parameters)
                .then(success => {
                    vm.artsSolicitations = success.Ticket;

                    for (let i = 0; i < vm.artsSolicitations.length; i++) {
                        const art = vm.artsSolicitations[i];
                        const timelineList = art.TicketTimeline;

                        timelineList.sort((a, b) => {
                            return new Date(a.RegistrationDate) - new Date(b.RegistrationDate);
                        }).reverse();

                        art.LastResponse = timelineList[0];
                    }

                    vm.numberOfPages = success.NumberOfPages;
                    vm.numberOfSolicitations = success.NumberOfTickets;
                    vm.numberOfSolicitationsOpened = success.NumberOfTicketsOpened;
                    vm.numberOfSolicitationsClosed = success.NumberOfTicketsClosed;
                    vm.isLoading = false;

                    $state.go('app-master.default.arts-solicitation-queue', {
                        artsSolicitationPage: vm.currentPage
                    });

                    HelperService.stopLoading('.arts-holder');
                    HelperService.stopLoading('.card');
                }, error => {
                    HelperService.errorCallback(error);
                })
        }

        function getStatus() {
            return HelpdeskService
                .getAllStatus()
                .then(
                    success => vm.status = success,
                    error => HelperService.errorCallback(error)
                );
        }

        function getArtTypes() {
            return HelpdeskService
                .getAllArtTypes()
                .then(
                    success => vm.artTypes = success,
                    error => HelperService.errorCallback(error)
                );
        }

        function prepareParameters() {
            let params = {
                PerPage: artsPerPage,
                Skip: artsSkip,
                OrderBy: 'RegistrationDate',
                OrderDescending: true,
                GetIndicators: true,
                IsArtsSolicitation: true,
                PersonId: AuthenticationService.getUserId()
            }

            if (queryString.getOnlyClosed != null)
                params.OnlyClosed = queryString.getOnlyClosed;

            if (vm.selectedArtTypes)
                params.ArtTypes = vm.selectedArtTypes.reduce(reduceFilters, []);

            if (vm.selectedStatus)
                params.TicketStatusId = vm.selectedStatus.Id;

            if (vm.datePicker.date.startDate) {
                params.StartDate = vm.datePicker.date.startDate.format('YYYY-MM-DD');
                params.EndDate = vm.datePicker.date.endDate.format('YYYY-MM-DD');
            }

            if (vm.searchText) {
                params.SearchField = 'PromotionDescription';
                params.SearchQuery = vm.searchText;
            }

            return params;
        }

        function reduceFilters(acc, cur) {
            acc.push(cur.Id);
            return acc;
        }

        function initVars() {
            artsPerPage = 5;
            artsSkip = 0;
            forcePaginationReset = false;
            isTableSearch = false;

            vm.currentPage = 1;
            vm.numberOfPages = 0;

            if (isNaN($stateParams.artsSolicitationPage)) {
                $state.go('app-master.default.arts-solicitation-queue', {
                    artsSolicitationPage: 1
                });
            } else
                vm.currentPage = $stateParams.artsSolicitationPage;

            vm.artsSolicitations = [];
            vm.isLoading = false;

            vm.currentHelpdesk = "Fila de Solicitações";

            vm.datePicker = {
                date: {
                    startDate: null,
                    endDate: null
                },
                options: {
                    'opens': 'left',
                    'maxDate': moment(),
                    'timePicker': false,
                    'format': 'DD/MM/YYYY',
                    'ranges': {
                        'Hoje': [
                            moment(),
                            moment()
                        ],
                        'Ontem': [
                            moment().subtract(1, 'days'),
                            moment().subtract(1, 'days')
                        ],
                        '7 Dias': [
                            moment().subtract(7, 'days'),
                            moment()
                        ],
                        '15 Dias': [
                            moment().subtract(15, 'days'),
                            moment()
                        ],
                        '30 Dias': [
                            moment().subtract(30, 'days'),
                            moment()
                        ]
                    }
                }
            };

            HelperService.startLoading('.page-filter');
        }

        function init() {
            initVars();

            $q.all([getStatus(), getArtTypes()])
                .then(() => {
                    HelperService.stopLoading('.page-filter');

                    vm.getPaginatedSolicitations({
                        page: vm.currentPage
                    });
                });
        }
    }
}());